import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross Blue Shield of Michigan",
  shortName: "BCBS Michigan",
  slug: "bcbsm-insurance",
  seoTitle:
    "Blue Cross Blue Shield of Michigan TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross Blue Shield of Michigan policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBS Michigan TMS coverage, Blue Cross Blue Shield Michigan SPRAVATO authorization, BCBSM mental health benefits Coral Springs FL, BCBS Michigan depression treatment Florida",
};

export const BcbsmInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbsmInsurance;
